export default __webpack_public_path__ + "static/media/invite.c6987228.svg";